import BackendConnector from './backendConnector';

export default class UserHttpService {
    static searchUsers({ filter, projection }) {
        return BackendConnector.post('users/search', { filter, projection });
    }

    static getCurrentUserOriginalRoleData() {
        return BackendConnector.get('user/getOriginalRoleData');
    }

    static stopCampaignActivityIntroduction({ id }) {
        return BackendConnector.put(`user/${id}/stopCampaignIntroduction`);
    }

    static stopCE3Introduction({ id }) {
        return BackendConnector.put(`user/${id}/stopCE3Introduction`);
    }

    static stopFastRatingIntroduction({ id }) {
        return BackendConnector.put(`user/${id}/stopFastRatingIntroduction`);
    }

    static stopProfileFeedbackModeIntro({ id }) {
        return BackendConnector.put(`user/${id}/stopProfileFeedbackModeIntro`);
    }

    static getLinkedinProfileStatus({ candidateLinkedinId, userLinkedinId }) {
        return BackendConnector.get(`user/connection/${userLinkedinId}/linkedin/${candidateLinkedinId}/status`);
    }

    static getLinkedinProfileStatuses({ candidateLinkedinIds, userLinkedinId }) {
        return BackendConnector.post(`user/connection/${userLinkedinId}/linkedin/statuses`, { candidateLinkedinIds });
    }

    static getLinkedinInvitesCount({ userLinkedinId, fromDate, toDate }) {
        return BackendConnector.get(`user/invites/${userLinkedinId}/linkedin/count`, { params: { fromDate, toDate } });
    }

    static async saveLastSelectedEmployer({ userId, employerId }) {
        return BackendConnector.post('user/saveLastSelectedEmployer', { userId, employerId });
    }

    static async isUserExists({ userId }) {
        return BackendConnector.post('user/exists', { userId });
    }

    static async isUserActive({ userId }) {
        return BackendConnector.post('user/isActive', { userId });
    }
}
